// Navbar.jsx
import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import logo from '../assets/Black Logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* 🔹 Logo - Fixed to link to home */}
        <div className="nav-logo">
          <Link to="/" aria-label="Home page" onClick={closeMenu}>
            <img 
              src={logo} 
              alt="Dilan Munasingha Photography" 
              className="logo-image"
            />
          </Link>
        </div>

        {/* 🔹 Menu List */}
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav">
            <Link to="/" className="nav-link" onClick={closeMenu}>
              Home
            </Link>
          </li>
          
          <li className="nav">
            <Link to="/portfolio" className="nav-link" onClick={closeMenu}>
              Portfolio
            </Link>
          </li>
          
          <li className="nav">
            <Link to="/works" className="nav-link" onClick={closeMenu}>
              Our Work
            </Link>
          </li>
          
          <li className="nav">
            <Link to="/about" className="nav-link" onClick={closeMenu}>
              About Me
            </Link>
          </li>
          
          
          
          <li className="nav">
            <Link to="/contact" className="nav-link" onClick={closeMenu}>
              Contact
            </Link>
          </li>
        </ul>

        {/* 🔹 Mobile Hamburger Menu */}
        <div
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
